import { useTranslation } from 'react-i18next';

export interface TablePageSelectorProps {
  pageSize: number;
  onPageSizeSelect: (v: number) => void;
}

function TablePageSelector(props: TablePageSelectorProps) {
  const { t } = useTranslation();
  const {
    pageSize,
    onPageSizeSelect,
  } = props;

  return (
    <div className="ct_tableFooter-controls">
      <div className="ct_tableFooter-label">
        {t(' Rows per page:')}
      </div>
      <div className="ct_tableFooter-control">
        <select
          value={pageSize}
          onChange={(e) => {
            onPageSizeSelect(Number(e.target.value));
          }}
        >
          {[1, 2, 5, 10, 20, 30, 40, 50, 100].map((size) => (
            <option key={size} value={size}>{size}</option>
          ))}
        </select>
      </div>
    </div>
  );
}

TablePageSelector.defaultProps = { ...{} };

export default TablePageSelector;
